import { defineComponent as o, openBlock as e, createBlock as r, unref as n, normalizeProps as u, guardReactiveProps as a, withCtx as s, renderSlot as p } from "vue";
import f from "./ghl-ui.es239.js";
const l = o({
  name: "UIButtonGroup",
  inheritAttrs: !1
}), c = o({
  ...l,
  setup(i) {
    return (t, _) => (e(), r(n(f), u(a(t.$attrs)), {
      default: s(() => [
        p(t.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), B = c;
export {
  B as default
};
